import { MotionFlex, type MotionFlexProps } from '@/ui';
import { ModalOverlay } from '@/ui';
import {
  MODAL_MAX_HEIGHT,
  MODAL_SIDEBAR_WIDTH,
  MODAL_VERTICAL_GUTTER,
} from '../../../constants';
import { useEntryModalContext } from '../../../contexts';

const transitionConfig = {
  duration: 0.2,
};

type Props = MotionFlexProps & {
  defaultOpen: boolean;
};

export const PanelLayout = ({ defaultOpen, ...props }: Props) => {
  const { activeSidebarPanel, slideSidebarUpFromBottom } =
    useEntryModalContext();

  const variants = {
    show: {
      // Slide the sidebar up from the bottom on mobile and out to the right on desktop
      translateX: slideSidebarUpFromBottom ? 0 : MODAL_SIDEBAR_WIDTH,
      translateY: 0,
      transition: transitionConfig,
    },
    hide: {
      translateX: 0,
      translateY: slideSidebarUpFromBottom ? '100%' : 0,
      transition: transitionConfig,
    },
  };

  return (
    <>
      {/* Overlay for the mobile UX */}
      <ModalOverlay
        animate={activeSidebarPanel ? 'show' : 'hide'}
        display={{ lg: 'none' }}
        zIndex={activeSidebarPanel ? undefined : -1}
        variants={{
          show: { opacity: 1, transition: transitionConfig },
          hide: { opacity: 0, transition: transitionConfig },
        }}
      />

      <MotionFlex
        animate={activeSidebarPanel ? 'show' : 'hide'}
        exit="hide"
        flexDir="column"
        initial={defaultOpen ? 'show' : 'hide'}
        maxH={{ base: 'var(--app-height)', md: `${MODAL_MAX_HEIGHT}px` }}
        p={{ base: 3, lg: 0 }}
        pb="0"
        position="absolute"
        right="0"
        variants={variants}
        width={slideSidebarUpFromBottom ? '100%' : MODAL_SIDEBAR_WIDTH}
        height={{
          base: 'var(--app-height)',
          md: `calc(var(--app-height) - ${MODAL_VERTICAL_GUTTER}px)`,
        }}
        zIndex={
          // Display the sidebar above the modal on mobile and underneath it on desktop
          slideSidebarUpFromBottom
            ? `calc(var(--chakra-zIndices-modal) + 1)`
            : -1
        }
        {...props}
      />
    </>
  );
};
